import { TestRunConfig } from '../types'

export function areConfigsEqual(a: TestRunConfig, b: TestRunConfig) {
  if (a.mode !== b.mode) {
    return false
  }

  if (a.botId !== b.botId) {
    return false
  }

  switch (a.mode) {
    case 'conversation':
      return a.testedUserId === (b as typeof a).testedUserId

    case 'scenario':
      return a.scenarioId === (b as typeof a).scenarioId
  }

  return false
}
